/**
 * Creates an AnswerButtonComponent
 * @param {EsgItem} answerEsgItem
 * @returns {string}
 * @constructor
 */
function AnswerRangeComponent(answerEsgItem) {
  return `
         <div class="grow">
              <p class="mt-1 text-sm text-gray-500 py-2">${answerEsgItem.item.title}</p>
              <div class="flex">
                <div class='flex-none px-2'>
                    ${answerEsgItem.item.range_min}&nbsp;${answerEsgItem.item.unit}
                </div>
                <div class="grow px-2">
                    <input type="range" class="disabled:opacity-75 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 
                                            w-full h-8 appearance-none rounded-full cursor-pointer outline-none focus:shadow-outline" />
                </div>
                <div class='flex-none px-2'>
                    ${answerEsgItem.item.range_max}&nbsp;${answerEsgItem.item.unit}
                </div>
              </div>
         </div>
    `;
}

export default AnswerRangeComponent;
